import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { HELP_PBXES } from "@/constants/HelpUrls";
import MasterDetail from "@/design/layouts/MasterDetail";
import { setHelpUrl } from "@/store/reducers/ui";

import Pbx from "./Pbx";
import PbxList from "./PbxList";

export default function Pbxes() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHelpUrl(HELP_PBXES));
  }, [dispatch]);

  return <MasterDetail identifier="context" master={<PbxList />} detail={<Pbx />} />;
}
